<template lang="html">
  <div class="apply">
    <common-header></common-header>
    <div class="page">
      <div class="wrapper-content container">
        <div class="ibox-title ">
            <h5 class="text-center">会员资料录入</h5>
        </div>
        <div class="box">
          <form>
            <div class="row border-bottom">
              <div class="col-sm-3">
                <div class="card" style="border:none;">
                  <div class="border" :data-titie="avatar?'':'照片'">
                    <img class="card-img-top" :src="avatar">
                  </div>
                  <div class="card-body">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" id="customFile" @change="uploadImage">
                      <label class="custom-file-label" for="customFile" :data-avatar="avatar?'重新上传':'上传图片'"></label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>姓名：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.name"  placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">笔名/艺名：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control"  v-model="form.penname" placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>性别：</label>
                  <div class="col-sm-8 alignCenter">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="form.gender" id="inlineRadio1" value="1" checked>
                      <label class="form-check-label" for="inlineRadio1">男</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="form.gender" id="inlineRadio2" value="0">
                      <label class="form-check-label" for="inlineRadio2">女</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row no-gutters ">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>出生日期：</label>
                  <div class="col-sm-8 position-relative">
                    <birth-date @getBirthdate="getBirthdate"></birth-date>
                    <!-- <input type="text" class="form-control" v-model="form.birthdate"  placeholder="" @click.stop.prevent="showDatepicker"> -->
                    <!-- <date-picker v-bind:show="datepickerShow" v-on:getChildDate="catchChildDate"></date-picker> -->
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>民族：</label>
                  <div class="col-sm-8">
                    <select id="inputState" class="form-control" v-model="form.nation">
                      <option value="">请选择民族</option>
                      <option v-for="(item,index) in nation" :value="item" :key="index">{{item}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>政治面貌：</label>
                  <div class="col-sm-8">
                    <select id="inputState" class="form-control" v-model="form.political">
                      <option value="">请选择政治面貌</option>
                      <option v-for="(item,index) in politicalBackground" :key="index" :value="item.name">{{item.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>文化程度：</label>
                  <div class="col-sm-8">
                    <select id="inputState" class="form-control" v-model="form.education">
                      <option value="">请选择文化程度</option>
                      <option v-for="(item,index) in culture" :key="index" :value="item">{{item}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>籍贯：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.birthplace"  placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>工作单位：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.employer"  placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>职务：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.position" placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>职称：</label>
                  <div class="col-sm-8">
                      <input type="text" class="form-control" v-model="form.positiontitle" placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label"><span class="red">*</span>身份证号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.idnumber" placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">申请协会：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.union" placeholder="" disabled>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">会员编号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.memberid" placeholder="">
                  </div>
                </div>
              </div>
            </div>
            <div class="row part border-bottom">
              <div class="col-sm-5">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label"><span class="red">*</span>通讯地址：</label>
                  <map-picker v-on:getAddress="catchAddress"></map-picker>
                  <div class="col-sm-8 offset-sm-3" style="margin-top:1rem;">
                    <input type="text" class="form-control" v-model="addressDetail" placeholder="详细地址">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">邮编：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.postcode" placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">办公电话：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.officephone"  placeholder="">
                  </div>
                </div>
              </div>
              <div class="col-sm-5 offset-sm-2">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">家庭电话：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.telephone"  placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label"><span class="red">*</span>微信号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.wechat"  placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3   col-form-label"><span class="red">*</span>手机号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.mobile" placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-3 col-form-label">电子信箱或个人网页：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.email"  placeholder="">
                  </div>
                </div>
              </div>
            </div>
            <div class="row part border-bottom">
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">国家级会员：</label>
                  <div class="col-sm-8 position-relative">
                    <!-- <input type="text" class="form-control" v-model="form.joindate_n" placeholder="入会时间（年月）" @click.stop.prevent="showDatepicker1"> -->
                    <month-picker v-bind:show="datepickerShow1" v-on:getChildDate="catchChildDate1"></month-picker>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">省级会员：</label>
                  <div class="col-sm-8 position-relative">
                    <!-- <input type="text" class="form-control" v-model="form.joindate_p" placeholder="入会时间（年月）" @click.stop.prevent="showDatepicker2"> -->
                    <month-picker v-bind:show="datepickerShow2" v-on:getChildDate="catchChildDate2"></month-picker>
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">市级会员：</label>
                  <div class="col-sm-8 position-relative">
                    <!-- <input type="text" class="form-control" v-model="form.joindate_c" placeholder="入会时间（年月）" @click.stop.prevent="showDatepicker3"> -->
                    <month-picker v-bind:show="datepickerShow3" v-on:getChildDate="catchChildDate3"></month-picker>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.mid_n" placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.mid_p"  placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">会员证编号：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.mid_c"  placeholder="">
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.posi_n" placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.posi_p"  placeholder="">
                  </div>
                </div>
                <div class="form-group row no-gutters">
                  <label for="staticEmail" class="col-sm-4 col-form-label">协会职务：</label>
                  <div class="col-sm-8">
                    <input type="text" class="form-control" v-model="form.posi_c" placeholder="">
                  </div>
                </div>
              </div>
            </div>
            <div class="row part step2 border-bottom">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 class="sub-tit"><span class="red">*</span>主要艺术成就及获奖情况：</h5>
                  </div>
                  <div class="col-sm-11" style="overflow-x: auto;">
                    <div class="">
                      <table class="table">
                        <thead class="">
                          <tr scope="row" >
                            <th scope="col">时间</th>
                            <th scope="col">地点</th>
                            <th scope="col">主办单位</th>
                            <th scope="col">著作出版社</th>
                            <th scope="col">作品或获奖情况</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <step-second v-bind:index="index" v-on:getRemoveIndex="catchRemoveIndex2" v-on:getFormData="catchStep2FormData" v-for="(item,index) in step2Group" :key="index"></step-second>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="btn btn-secondary" @click="addStep2">
                      增加
                    </div>
                  </div>
                  <div class="row col-sm-12 upload-image">
                    <div class="col-sm-auto " v-if="!photos.length">
                      <div class="example-img fixedWidth" >
                      </div>
                    </div>
                    <div class="col-sm-auto" v-if="photos.length  " v-for="(item,index) in photos">
                      <div class="example-img position-relative" >
                        <img :src="item" alt="">
                        <span class="delPhoto" @click="removePhoto(index)">×</span>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="custom-file">
                        <input type="file" class="custom-file-input" id="customFile" @change="photosUpload">
                        <label class="custom-file-label" for="customFile"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row part step2">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12">
                    <h5 class="sub-tit"><span class="red">*</span>主要经历：</h5>
                  </div>
                  <div class="col-sm-11" style="overflow-x: auto;">
                    <div class="">
                      <table class="table">
                        <thead class="">
                          <tr scope="row" >
                            <th scope="col">起始年月</th>
                            <th scope="col">结束年月</th>
                            <th scope="col">主要经历</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <step-third v-bind:index="index" v-on:getRemoveIndex="catchRemoveIndex3" v-on:getFormData="catchStep3FormData" v-for="(item,index) in step3Group" :key="index"></step-third>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="btn btn-secondary" @click="addStep3">
                      增加
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row part">
              <div class="col-sm-12">
                <h5 class="sub-tit">参加文艺志愿活动情况：</h5>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <textarea class="form-control" ></textarea>
                </div>
              </div>
            </div> -->
          </form>
        </div>
      </div>

    </div>
    <div class="row justify-content-md-center">
      <div class="form-group" style="margin: 0 auto;">
        <div class="btn btn-primary" @click="save">
          保存
        </div>
      </div>
    </div>
    <loading-model v-bind:show="isLoading"></loading-model>
    <alert-model v-bind:show="alertShow" v-bind:func="alertFunc" v-on:close="catchClose" v-bind:msg="tips"></alert-model>
  </div>
</template>

<script>
import commonHeader from './header.vue'
import stepSecond from './step2.vue'
import stepThird from './step3.vue'
import mapPicker from './map.vue'
import datePicker from './datepicker.vue'
import monthPicker from './monthpicker.vue'
import birthDate from './birthdate.vue'
import loadingModel from './loading.vue'
import alertModel from './alert.vue'
export default {
  components: {
    commonHeader,
    mapPicker,
    stepSecond,
    stepThird,
    datePicker,
    monthPicker,
    birthDate,
    loadingModel,
    alertModel
  },
  data() {
    return {
      alertFunc: '',
      alertShow: false,
      tips: '',
      isLoading: false,
      group: [],
      posiTitle: [],
      nation: '',
      politicalBackground: '',
      culture: '',
      address: '',
      addressDetail: '',
      avatar: '',
      form: {
        name: '',
        penname: '',
        gender: '1',
        birthdate: '',
        nation: '',
        political: '',
        education: '',
        birthplace: '',
        employer: '',
        position: '',
        positiontitle: '',
        idnumber: '',
        union: group[0],
        address: '',
        telephone: '',
        email: '',
        postcode: '',
        wechat: '',
        officephone: '',
        mobile: '',
        joindate_n: '',
        joindate_p: '',
        joindate_c: '',
        mid_n: '',
        mid_p: '',
        mid_c: '',
        posi_n: '',
        posi_p: '',
        posi_c: '',
        photo: ''
      },
      step2Group: [1],
      step2Count: 1,
      step2FormData: [],
      step3Group: [1],
      step3Count: 1,
      step3FormData: [],
      datepickerShow: false,
      datepickerShow1: false,
      datepickerShow2: false,
      datepickerShow3: false,
      photos: []
    }
  },
  methods: {
    removePhoto(index) {
      this.photos.splice(index, 1)
    },
    catchRemoveIndex3(index) {
      this.step3Group.splice(index, 1)
    },
    catchRemoveIndex2(index) {
      this.step2Group.splice(index, 1)
    },
    catchClose(data) {
      this.alertShow = data.show
    },
    alert(msg, func) {
      this.alertShow = true
      this.tips = msg
      this.alertFunc = func
    },
    getBirthdate(date) {
      this.form.birthdate = date.birthdate
    },
    catchChildDate1(date) {
      this.form.joindate_n = date.date
      this.datepickerShow = false
      this.datepickerShow1 = false
      this.datepickerShow2 = false
      this.datepickerShow3 = false
    },
    catchChildDate2(date) {
      this.form.joindate_p = date.date
      this.datepickerShow = false
      this.datepickerShow1 = false
      this.datepickerShow2 = false
      this.datepickerShow3 = false
    },
    catchChildDate3(date) {
      this.form.joindate_c = date.date
      this.datepickerShow = false
      this.datepickerShow1 = false
      this.datepickerShow2 = false
      this.datepickerShow3 = false
    },
    showDatepicker1() {
      this.datepickerShow1 = !this.datepickerShow1
    },
    showDatepicker2() {
      this.datepickerShow2 = !this.datepickerShow2
    },
    showDatepicker3() {
      this.datepickerShow3 = !this.datepickerShow3
    },
    save() {
      let formData1 = []
      let formData2 = []
      this.form.address = `${this.address}${this.addressDetail}`
      for (let i = 0; i < this.step2FormData.length; i++) {
        formData1.push(this.step2FormData[i])
      }
      let params = {
        data: this.form,
        photos: this.photos,
        awards: formData1,
        resume: this.step3FormData
      }
      let config = {
        headers: {
          'Content-Type': 'text/plain'
        }
      }
      this.$axios.post("/api/wenlian/mgradd", params, config).then(res => {
        if (res.data.result == 1) {
          this.alert(res.data.msg, () => {
            this.$router.push('dataTypein')
          })
        } else {
          this.alert(res.data.msg)
        }

      })
    },
    catchChildDate(date) {
      this.form.birthdate = date
      this.datepickerShow = false
    },
    showDatepicker() {
      this.datepickerShow = !this.datepickerShow
    },
    catchAddress(data) {
      console.log(data, "-----")
      this.address = data
    },
    catchStep2FormData(data) {
      this.step2FormData[data.index] = (data.formData[data.index])
    },
    catchStep3FormData(data) {
      console.log(data)
      this.step3FormData[data.index] = (data.formData[data.index])
    },
    addStep2() {
      this.step2Count++
      this.step2Group.push(this.step2Count)
    },
    addStep3() {
      this.step3Count++
      this.step3Group.push(this.step2Count)
    },
    uploadImage(e) {
      this.loading = true
      let that = this
      let img = e.target.files[0];
      let param = new FormData()
      param.append('file', img)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$axios.post('/api/wenlian/upload', param, config)
        .then(res => {
          this.loading = false
          if (res.data.result === 1) {
            this.avatar = res.data.url
            this.alert(res.data.msg)
          } else {
            this.alert(res.data.msg)
          }
        })
    },
    photosUpload(e) {
      let that = this
      let img = e.target.files[0];
      let param = new FormData()
      param.append('file', img)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$axios.post('/api/wenlian/upload', param, config)
        .then(res => {
          if (res.data.result === 1) {
            this.photos.push(res.data.url)
            this.alert(res.data.msg)
          } else {
            this.alert(res.data.msg)
          }
        })
    },
  },
  mounted() {
    this.nation = nation
    this.politicalBackground = politicalBackground
    this.culture = culture
    this.group = group
    this.posiTitle = posiTitle
    this.form.union = this.$store.state.user.union
  }
}
</script>

<style lang="css" scoped>
.delPhoto {
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 999;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #f31a1a;
  color: #fff;
  line-height: 22px;
  text-align: center;
  font-size: 25px;
}
.apply .btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}
.apply .btn-primary {
  background-color: #18a689;
  border-color: #18a689;
  width: 200px;
}
.apply .btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}
.apply .btn-primary.disabled {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}
.apply .part {
  padding: 20px 0;
}
.apply .border {
  width: 100%;
  min-height: 360px;
  position: relative;
  overflow: hidden;
}
.apply .border::after {
  content: attr(data-title);
  position: absolute;
  color: #999;
  font-size: 14px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
.apply .border img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  z-index: 9999;
  width: 100%;
  height: auto;
}
.apply .fullScreen {
  height: 100%;
}
.apply .page-link {
  color: #33434b;
}
.apply .page-link:hover {
  background: #f4f4f4;
  color: #33434b;
}
.apply .page-link.active {
  background: #f4f4f4;
}
.apply .custom-file-label::after {
  content: attr(data-avatar);
  border-radius: 0.25rem;
  text-align: center;
  width: 100%;
  height: 100%;
}
.apply .custom-file-label {
  border: none;
}
.apply .red {
  color: red;
  margin: 0 5px;
}
.apply .form-group label {
  font-size: 15px;
  color: #33434b;
}
.apply input,
.apply select,
.apply option,
.apply .textarea,
.apply .form-check label {
  color: #33434b;
  font-size: 15px;
}
.apply .step2 .custom-file-label::after {
  content: "证明材料上传";
  border-radius: 0.25rem;
  text-align: center;
  width: 100%;
  height: 100%;
}
.apply .step2 .custom-file-label {
  border: none;
}
.apply .step2 .red {
  color: red;
  margin: 0 5px;
}
.apply .step2 .sub-tit {
  color: #33434b;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 15px;
}
.apply .step2 table td,
table th {
  color: #333;
}
.apply .step2 .table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: none;
}
.apply .step2 .form-group {
  margin-bottom: 0;
}
.apply .step2 .upload-image {
  margin-top: 20px;
}
.apply .step2 .upload-image img {
  height: 150px;
  width: auto;
}
.apply .step2 .custom-file {
  margin-top: 0%;
}
.apply .step2 .example-img {
  height: 150px;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  position: relative;
}
.apply .step2 .example-img:after {
  content: "+";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #33434b;
  font-size: 50px;
}
.apply .step2 .border {
  min-height: auto;
}
.apply .step2 .border::after {
  content: "";
}
.apply .sub-tit {
  color: #33434b;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 15px;
}
.apply textarea {
  min-height: 200px;
}
.apply .example-img {
  height: 150px;
  min-width: 50px;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  position: relative;
  display: flex;
  justify-content: center;
}
.apply .fixedWidth {
  width: 200px;
}
.apply .example-img > img {
  position: relative;
  z-index: 999;
}
@media screen and (max-width: 750px) {
  .col-form-label {
    text-align: left;
  }
  .table {
    width: 1400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/applyForm.vue